var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "firm" },
    [
      _c(
        "b-row",
        [
          _c("csp-desktop-firm-basedata", {
            attrs: {
              cols: 8,
              "form-context": _vm.initialFormContexts.firmBasedata,
              "is-creation-form": true,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }